import { DocumentDTO } from 'entities/orderAttachments/model/dtoTypes'
import { Document } from 'entities/orderAttachments/model/types'

export const adaptDocumentDTO = (source: DocumentDTO): Document => ({
    id: source.id,
    fileName: source.filename,
    hashName: source.hash_name,
    uploadUrl: source.upload_url,
})
